export default "__VITE_ASSET__88f19ac4__"